module.exports = __webpack_public_path__ + "img/battery.d00f5adc.svg";